import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

type TMaxWidth = 'large' | 'xlarge';

const MaxWidthMapper: Record<TMaxWidth, string> = {
  large: 'max-w-7xl',
  xlarge: 'max-w-[1420px]',
};

@Component({
  selector: 'app-content-container',
  imports: [],
  template: `
    <div class="flex justify-center w-full h-full">
      <div class="w-full p-6 xl:p-3" [class]="resolvedMaxWidth()">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentContainer {
  maxWidth = input<TMaxWidth>('large');

  resolvedMaxWidth = computed(() => {
    return MaxWidthMapper[this.maxWidth()];
  });
}
